import { Link } from "react-router-dom"

import youtube from "@/assets/images/platforms/youtube.png"
import facebook from "@/assets/images/platforms/facebook.png"
import instagram from "@/assets/images/platforms/instagram.webp"
import angkorlife from "@/assets/images/platforms/angkorlifeColor.ico"
import { useInView } from "react-intersection-observer"

interface Props {
  title: string
  linked?: string
}

const imageMap: Record<string, string> = {
  youtube,
  facebook,
  instagram,
  angkorlife,
}

const Platforms = ({ title, linked }: Props) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })
  const icon = imageMap[title]

  return (
    <div>
      <Link
        target="_blank"
        to={linked ?? ""}
        className="flex justify-center items-center mx-auto rounded-full border bg-background-primary size-8 border-gray-05"
        ref={ref}
      >
        {inView && (
          <img
            src={icon}
            alt={title}
            className={`size-6 ${title === "facebook" ? "size-3" : ""}`}
            loading="lazy"
          />
        )}
      </Link>
    </div>
  )
}

export default Platforms
